// src/domains/user/userSettings.store.ts

import { create } from 'zustand';
import { devtools, persist } from 'zustand/middleware';
import { IUserSettings, TLightMode } from './user.types';
import { USER_SETTINGS } from './user.const';
import { customStorage } from '@/shared/lib/storage';
import { registerClear } from '@/shared/lib/storesRegistry';

interface IUserSettingsStore {
  settings: IUserSettings;
  setSettings: (settings: IUserSettings) => void;
  toggleMenuCollapsed: () => void;
  toggleLightMode: (mode: TLightMode) => void;
  clearSettings: () => void;
}

export const useUserSettingsStore = create<IUserSettingsStore>()(
  devtools(
    persist(
      (set) => ({
        settings: USER_SETTINGS,
        setSettings: (settings: Partial<IUserSettings>) =>
          set((state) => ({
            settings: { ...state.settings, ...settings },
          })),
        toggleMenuCollapsed: () =>
          set((state) => ({
            settings: {
              ...state.settings,
              menu_collapsed: !state.settings.menu_collapsed,
            },
          })),
        toggleLightMode: (mode: TLightMode) =>
          set((state) => ({
            settings: {
              ...state.settings,
              light_mode: mode,
            },
          })),
        clearSettings: () => set({ settings: USER_SETTINGS }),
      }),
      { name: 'user-settings-storage', storage: customStorage },
    ),
    { name: 'UserSettingsStore' },
  ),
);

registerClear(useUserSettingsStore.getState().clearSettings);
